import { useSyncExternalStore } from "react"

// Whether the Strategy Tester panel is collapsed: this browser's preference,
// shared by the panel and by whatever adds a strategy (which opens it).

// v2: v1 could be flipped by clicks on the panel's title while it showed nothing.
const COLLAPSED_KEY = "trader.tester.collapsed.v2"

const load = (): boolean => {
  try {
    return localStorage.getItem(COLLAPSED_KEY) === "true"
  } catch {
    return false
  }
}

let collapsed = load()
const listeners = new Set<() => void>()

export const testerPanel = {
  setCollapsed: (next: boolean): void => {
    if (next === collapsed) return
    collapsed = next
    try {
      localStorage.setItem(COLLAPSED_KEY, String(next))
    } catch {
      // Not remembered; the panel still works.
    }
    for (const listener of listeners) listener()
  },
  open: (): void => testerPanel.setCollapsed(false)
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export const useTesterCollapsed = (): boolean => useSyncExternalStore(subscribe, () => collapsed)
